module.exports = __webpack_public_path__ + "static/media/Home-Background.2da57e2f.jpg";